import { loadStripe } from "@stripe/stripe-js";

export const stripePromise = loadStripe(
  "pk_test_51SDPlp39fICDkyA9dOEfdESWl0m9ChIRrAWp7e383aE8DyNmLr1dFmRUWSTzKFAqcpSzDIWQxr3Ktkaz8HWBMOHX00j37EtSDQ"
);
